import { mutationTypes } from './mutation-types';
// import accountApi from "../api/account.module"
import { accountManagementApi } from '../api/user/accountManagementApi';
import { partnerApi } from '../api/partner/partnerApi';
//import { affiliateApi } from '../api/affiliate/affiliateApi';
import { messagesApi } from '../api/user/messagesApi';
import { commonApi } from '../api/commonApi';
import { coinToCoinAccountApi } from '@/api/coinToCoinAccount/coinToCoinAccountApi';
import { indexApi } from '../api/indexApi';
import { affiliateApi } from '../api/affiliate/affiliateApi';
import { rewardApi } from "../api/reward/rewardApi";
import { marketApi } from '@/api/marketApi';
import tools from '../common/js/tool';
import i18n from '@/translations';
// import { Cookies } from 'quasar';

import store from './index';
import { actionTypes } from './action-types';
import { assetsApi } from '../api/assetsApi';
import { isEmpty } from '@/common/mixin/common';

export default {
  [actionTypes.CLEAR_USERINFO_ACTION]({ commit }, flag) {
    store.commit(mutationTypes.SET_EXPIRETIME, '');
    store.commit(mutationTypes.SET_TOKEN, '');
    store.commit(mutationTypes.SET_USERNAME, '');
    store.commit(mutationTypes.SET_PARTNER_INFO, {});
    store.commit(mutationTypes.SET_AFFILIATE_PARTNER_INFO, {});

    if (!flag) {
      store.commit(mutationTypes.SET_CURRENCY, '');
      store.commit(mutationTypes.SET_LANG, '');
    }
    // Cookies.set('isLogin', false);
  },
  // 设置用户中心页面标题
  setMobileRightNavShow_action({ commit }, show) {
    commit(mutationTypes.SET_MOBILERIGHTNAVSHOW, show);
  },
  // 获取用户详情信息
  [actionTypes.GET_USERINFO_ACTION]({ commit }) {
    return accountManagementApi.getUserInfo().then(res => {
      commit(mutationTypes.SET_USERINFO, res.data);
      return res;
    });
  },

  // TIP 获取，所有币种，列表
  [actionTypes.GET_COIN_LIST_ACTION]({ commit }) {
    return assetsApi.coin_api.getBaseCoinList().then(res => {
      commit(mutationTypes.SET_COIN_LIST, res.data); // res.data，是一个列表。
      return res;
    });
  },
  // 获取未读消息数量
  getUnreadMessageCount_action({ commit }) {
    return messagesApi.getUnreadNotificationsCount().then(res => {
      commit(mutationTypes.SET_UNREADMESSAGECOUNT, res.data ? res.data : 0);
      return res;
    });
  },
  // 获取所有语言
  [actionTypes.GET_LANGS_ACTION]({ commit }) {
    return commonApi.getLanguage().then(res => {
      let data = res.data;
      if (data && data.length > 0) {
        commit(mutationTypes.SET_LANGS, data);
      }
      return res;
    });
  },
  // 获取所有货币
  [actionTypes.GET_CURRENCIES_ACTION]({ commit }) {
    return commonApi.getCurrency().then(res => {
      let data = res.data;
      if (data && data.length > 0) {
        commit(mutationTypes.SET_CURRENCIES, data);
      }
      return res;
    });
  },
  [actionTypes.GET_ALL_COIN_ACTION]({ commit }) {
    return coinToCoinAccountApi
      .getAllCoinInfo() // get all coin info. Used for withdrawal limit decimal
      .then(res => {
        const data = res.data;
        commit(mutationTypes.SET_ALL_COIN, data);
        return data;
      });
  },
  [actionTypes.GET_ASSETS_ACTION]({ commit }) {
    return coinToCoinAccountApi
      .getAccount() // get account assets info
      .then(res => {
        const assetsList = res.data.assertList;
        let filteredAssetList = [];
        if (assetsList.length > 0) {
          for (let index in assetsList) {
            let tmp = assetsList[index];
            filteredAssetList[index] = {
              label: tmp['coinName'],
              value: tmp['coinId'],
            };
          }
        }
        commit(mutationTypes.SET_ASSETS, filteredAssetList);
        return res;
      });
  },
  // TIP 获取所有交易市场
  [actionTypes.GET_MARKETLIST_ACTION]({ commit }) {
    return marketApi.getMarketList().then(res => {
      let data = res.data;
      if (data && data.length > 0) {
        data = data.reduce(
          (prevVal, curVal) => {
            prevVal[curVal.symbol] = curVal;
            return prevVal;
          },
          {} /* By putting {}, the value of prevVal in the first loop will be {} */
        );
        commit(mutationTypes.SET_MARKETLIST, data);
      }
      return res;
    });
  },
  // TIP 获取所有币币交易对列表
  [actionTypes.GET_TRADING_PAIRS_LIST_ACTION]({ commit }) {
    return indexApi.get_TradingPairsAll_list().then(res => {
      let data = res.data;
      if (data && data.length > 0) {
        commit(mutationTypes.SET_TRADING_PAIRS_LIST, data);
      }
      return res;
    });
  },
  [actionTypes.GET_USER_VIP_ACTION]({ commit }) {
    return accountManagementApi.getUserVip().then(res => {
      let data = res.data;
      if (!isEmpty(data)) {
        commit(mutationTypes.SET_USER_VIP, data);
      }
      return res;
    });
  },
  [actionTypes.GET_WECHAT_QRCODE_ACTION]({commit}) {
    return commonApi.getWechatQrCode().then(res => {
      let data = res.data;
      if (!isEmpty(data)) {
        commit(mutationTypes.SET_WECHAT_QRCODE_STATE, data.link);
      }
      return res;
    })
  },
  [actionTypes.GET_AFFILIATE_PARTNER_INFO_ACTION]({ commit }) {
    return accountManagementApi.getAffiliateAndPartnerInfo().then(res => {
      let data = res.data;
      commit(mutationTypes.SET_AFFILIATE_PARTNER_INFO, data);
      return res;
    })
  },
  [actionTypes.GET_PARTNER_INFO_ACTION]({ commit }) {
    return partnerApi.getPartnerInfo().then(res => {
      let data = res.data;
      commit(mutationTypes.SET_PARTNER_INFO, data);
      return res;
    })
  },
  [actionTypes.GET_PARTNER_TYPE_ACTION]({ commit }) {
    return partnerApi.getPartnerTypeData().then(res => {
      let data = res.data;
      if (data.length > 0) {
        data = tools.convertArrToOptions(data, 'display', 'value');
        commit(mutationTypes.SET_PARTNER_TYPE, data);
      }
      return res;
    })
  },
  [actionTypes.GET_AFFILIATE_TYPE_ACTION]({ commit }) {
    return affiliateApi.getAffiliateTypeData().then(res => {
      let data = res.data;
      if (data.length > 0) {
        data = tools.convertArrToOptions(data, 'display', 'value');
        commit(mutationTypes.SET_AFFILIATE_TYPE, data);
      }
      return res;
    })
  },
  [actionTypes.GET_REWARD_CATEGORIES_ACTION]({ commit }) {
    return rewardApi.getRewardCategory().then(res => {
      let data = res.data;
      if (data.length > 0) {
        data = tools.convertArrToOptions(data, 'display', 'category');
        data.unshift({ label: i18n.t('common.all'), value: '' });
        commit(mutationTypes.SET_REWARD_CATEGORIES, data);
      }
      return res;
    })
  },
};
